<template>
  <div>
    <div class="actions-form-container">
      <multiselect v-model="template" :max-height="200" label="name" track-by="name"
                   placeholder="Choose grouping" :options="templates" @select="applyTemplate"
                   select-label="" deselect-label="" selected-label="" :disabled="!rowData.length"></multiselect>
      <div>
        <b-btn size="sm" title="Save template" @click="createTemplate" :disabled="!rowData.length">
          {{$t('buttons.common.save')}}
        </b-btn>
        <b-btn size="sm" variant="outline-danger" title="Delete selected template" :disabled="!rowData.length"
               @click="deleteSelectedTemplate">
          {{$t('buttons.common.delete')}}
        </b-btn>
        <b-btn size="sm" variant="outline-success" title="Update selected template" :disabled="!rowData.length"
               @click="updateSelectedTemplate">
          {{$t('buttons.common.update')}}
        </b-btn>
      </div>
      <div class="action-btns">
        <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
             :title="$t('buttons.common.clear_filters')">
        <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
             :title="$t('buttons.common.search')">
      </div>
    </div>
    <div class="search-form-container">
      <div>
        <label>{{$t('labels.order_products.planning_period')}}</label>
        <multiselect v-model="searchData.period" :max-height="200"
                     placeholder="Choose planning period" :options="periods" :allow-empty="false"
                     select-label="" deselect-label="" selected-label=""></multiselect>
      </div>
      <div>
        <label>{{$t('labels.common.buyer')}}</label>
        <multiselect v-model="searchData.partner" :max-height="200" label="name" track-by="name"
                     placeholder="Choose buyer" :options="customers" :multiple="true" :close-on-select="false"
                     select-label="" deselect-label="" selected-label=""></multiselect>
      </div>
      <div>
        <label>{{$t('labels.order_products.order_status')}}</label>
        <multiselect v-model="searchData.status" :max-height="200" label="name" track-by="name"
                     placeholder="Choose status" :options="orderStatuses" :multiple="true"
                     :close-on-select="false" select-label="" deselect-label="" selected-label=""></multiselect>
      </div>
      <div>
        <label>{{$t('labels.order_products.period_dimension')}}</label>
        <multiselect v-model="searchData.periodDimensions" :max-height="200" :close-on-select="false"
                     placeholder="Choose total dimensions" :options="dimensions" :multiple="true"
                     select-label="" deselect-label="" selected-label="" :allow-empty="false"
                     @input="changeHideStateOfColumns(false)"></multiselect>
      </div>
      <div v-show="searchData.period === 'Week'">
        <label>{{$t('labels.order_products.week_from')}}</label>
        <input class="form-control week-picker" type="text" id="start_week" placeholder="Select start week"/>
      </div>
      <div v-show="searchData.period === 'Month'">
        <label>{{$t('labels.order_products.month_from')}}</label>
        <datepicker v-model="searchData.start_month"
                    lang="en"
                    :width="170"
                    placeholder="Select start month"
                    format="YYYY-MM"
                    type="month"
        ></datepicker>
      </div>
      <div>
        <label>{{$t('labels.common.delivery_address')}}</label>
        <multiselect v-model="searchData.delivery_addresses" :max-height="200" :close-on-select="false"
                     label="name" track-by="name" placeholder="Choose delivery address"
                     :options="delivery_addresses" :multiple="true"
                     select-label="" deselect-label="" selected-label=""></multiselect>
      </div>
      <div>
        <label>{{$t('labels.common.creator')}}</label>
        <multiselect v-model="searchData.sales_order_created_by" :max-height="200" :close-on-select="false"
                     label="username" track-by="username" placeholder="Choose creator"
                     :options="creators" :multiple="true"
                     select-label="" deselect-label="" selected-label=""></multiselect>
      </div>
      <div>
        <label>{{$t('labels.order_products.total_dimension')}}</label>
        <multiselect v-model="searchData.totalDimensions" :max-height="200" :close-on-select="false"
                     placeholder="Choose period dimensions" :options="dimensions" :multiple="true"
                     select-label="" deselect-label="" selected-label="" :allow-empty="false"
                     @input="changeHideStateOfColumns"></multiselect>
      </div>
      <div v-show="searchData.period === 'Week'">
        <label>{{$t('labels.order_products.week_to')}}</label>
        <input class="form-control week-picker" type="text" id="end_week" placeholder="Select end week"/>
      </div>
      <div v-show="searchData.period === 'Month'">
        <label>{{$t('labels.order_products.month_to')}}</label>
        <datepicker v-model="searchData.end_month"
                    lang="en"
                    :width="170"
                    placeholder="Select end month"
                    format="YYYY-MM"
                    type="month"
        ></datepicker>
      </div>
      <div>
        <label>{{$t('labels.common.order')}}</label>
        <input class="form-control" v-model="searchData.descriptor" placeholder="Etner order">
      </div>
      <div>
        <label>{{$t('labels.common.smart_search')}}</label>
        <input class="form-control" v-model="searchData.smart_search">
      </div>
      <div>
        <label>{{$t('labels.common.delivery_method')}}</label>
        <multiselect v-model="searchData.delivery_method" :max-height="200" :close-on-select="false"
                     label="name" track-by="name" placeholder="Choose delivery methods"
                     :options="delivery_methods" :multiple="true"
                     select-label="" deselect-label="" selected-label=""></multiselect>
      </div>
      <div>
        <label>{{$t('labels.common.stock')}}</label>
        <multiselect v-model="searchData.stock_addresses" :max-height="200" :close-on-select="false"
                     label="name" track-by="name" placeholder="Choose stock"
                     :options="stock_addresses" :multiple="true"
                     select-label="" deselect-label="" selected-label=""></multiselect>
      </div>
    </div>
    <ordered-product-modal></ordered-product-modal>
    <div class="grid-container">
      <div class="d-flex justify-content-end">
        <b-btn variant="outline-secondary" size="sm" @click="excelExport" title="Excel export">
          <icon name="file-excel"></icon>
          {{$t('buttons.common.export')}}
        </b-btn>
      </div>
      <ag-grid-vue class="ag-theme-balham grid" :style="gridHeight" :columnDefs="columns" :rowData="rowData"
                   :gridOptions="gridOptions" @cellDoubleClicked="openOrderedProductDialog"
                   :postProcessPopup="postProcessPopup">
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import { AgGridVue } from 'ag-grid-vue';
  import OrderedProductModal from '@/components/modals/OrderedProductModal';
  import { convertToWeekPicker } from '@/plugins/week-picker/week-picker';
  import {
    getArrayByProperty,
    handlerResponse,
    setNotifyData,
    cleanFilters,
    saveFilters,
    checkSavedFilterData,
    setFilters,
    getFileNameFromContentDisposition
  } from '@/helpers/commonHelpers';
  import { alignCells, formatNumber, notificationsRenderer } from '@/helpers/renderHelpers';
  import { existenceFloatingAndBundles } from '@/helpers/order-products-helpers';
  import gridProps from '@/gridProps';
  import { saveAs } from 'file-saver';
  import { gridMixins } from '@/mixins';

  import moment from 'moment';

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      Datepicker,
      AgGridVue,
      OrderedProductModal
    },
    data() {
      return {
        template: null,
        templates: [],
        orderStatuses: [{key: 'forecast', name: 'Forecast'}, {key: 'final', name: 'Confirmed'}],
        dimensions: ['m3', 'm2', 'lm', 'pieces'],
        periods: ['Week', 'Month'],
        periodList: [],
        searchData: {
          period: '',
          periodDimensions: [],
          totalDimensions: [],
          partner: [],
          status: [],
          delivery_addresses: [],
          sales_order_created_by: [],
          descriptor: '',
          smart_search: '',
          start_month: null,
          end_month: null,
          delivery_method: [],
          stock_addresses: []
        },
        columns: [],
        childColumns: [
          {
            headerName: 'm3',
            key: 'm3',
            aggFunc: 'sum'
          },
          {
            headerName: 'm2',
            key: 'm2',
            aggFunc: 'sum'
          },
          {
            headerName: 'lm',
            key: 'lm',
            aggFunc: 'sum'
          },
          {
            headerName: 'pcs',
            key: 'pieces',
            aggFunc: 'sum'
          }
        ],
        rowData: [],
        gridOptions: {
          groupHideOpenParents: true,
          suppressColumnVirtualisation: true,
          rowGroupPanelShow: 'always',
          suppressPropertyNamesCheck: true,
          components: {
            existenceFloatingAndBundles: existenceFloatingAndBundles
          },
          defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            enableRowGroup: true,
            valueFormatter(params) {
              return formatNumber(params.value, null);
            },
            cellStyle(params) {
              return alignCells(params);
            }
          },
          getRowStyle(params) {
            if (params.node.rowPinned) {
              return {'font-weight': 'bold'};
            }
          },
          autoGroupColumnDef: {
            pinned: 'left',
            width: 140
          },
          ...gridProps
        },
        gridNameForTemplates: 'ordered_products'
      }
    },
    methods: {
      setDefaultData() {
        this.searchData.period = 'Week';
        this.searchData.status = [{key: 'forecast', name: 'Forecast'}, {key: 'final', name: 'Confirmed'}];
        this.searchData.periodDimensions = ['m3', 'm2', 'lm', 'pieces'];
        this.searchData.totalDimensions = ['m3'];
      },
      initializeGridColumns() {
        return [
          {
            headerName: '',
            pinned: 'left',
            cellRenderer: existenceFloatingAndBundles,
            width: 25,
          },
          {field: 'TxWxL', colId: 'TxWxL', headerName: 'TxWxL', pinned: 'left', width: 63},
          {field: 'thickness', colId: 'thickness', headerName: 'Thickness', pinned: 'left', width: 58, hide: true},
          {field: 'width', colId: 'width', headerName: 'Width', pinned: 'left', width: 58, hide: true},
          {field: 'length', colId: 'length', headerName: 'Length', pinned: 'left', width: 58, hide: true},
          {
            field: 'group__name',
            colId: 'group__name',
            headerName: 'Group',
            key: 'description__product_group_desc__name',
            width: 61,
            pinned: 'left'
          },
          {
            field: 'tree__name',
            colId: 'tree__name',
            headerName: 'Wood',
            key: 'tree__name',
            width: 60,
            pinned: 'left'
          },
          {
            field: 'profile__name',
            colId: 'profile__name',
            headerName: 'Profile',
            key: 'profile__name',
            width: 62,
            pinned: 'left'
          },
          {
            field: 'quality__name',
            colId: 'quality__name',
            headerName: 'Qual.',
            key: 'quality__name',
            width: 55,
            pinned: 'left'
          },
          {field: 'humidity', colId: 'humidity', headerName: 'Humd.', key: 'humidity', width: 63, pinned: 'left'},
          {
            field: 'impr__name',
            colId: 'impr__name',
            headerName: 'Impr.',
            key: 'impr__name',
            width: 55,
            pinned: 'left'
          },
          {
            field: 'impr__synonym__name',
            colId: 'impr__synonym__name',
            headerName: 'Syn. impr.',
            key: 'impr__synonym__name',
            width: 81,
            pinned: 'left'
          },
          {
            field: 'wood_certificate__name',
            colId: 'wood_certificate__name',
            headerName: 'Certificate',
            key: 'wood_certificate__name',
            width: 82,
            pinned: 'left'
          },
          {
            field: 'ordered_m3',
            colId: 'ordered_m3',
            headerName: 'ORD(m3)',
            width: 77,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum',
          },
          {
            field: 'overload_m3',
            colId: 'overload_m3',
            headerName: 'OVR(m3)',
            width: 76,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'stock_m3',
            colId: 'stock_m3',
            headerName: 'STOCK(m3)',
            width: 89,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum',
          },
          {
            field: 'diff_m3',
            colId: 'diff_m3',
            headerName: 'DIFF(m3)',
            width: 76,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum',
          },
          {
            field: 'ordered_lm',
            colId: 'ordered_lm',
            headerName: 'ORD(lm)',
            width: 78,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'overload_lm',
            colId: 'overload_lm',
            headerName: 'OVR(lm)',
            width: 78,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'stock_lm',
            colId: 'stock_lm',
            headerName: 'STOCK(lm)',
            pinned: 'right',
            width: 90,
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'diff_lm',
            colId: 'diff_lm',
            headerName: 'DIFF(lm)',
            width: 78,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum',
          },
          {
            field: 'ordered_m2',
            colId: 'ordered_m2',
            headerName: 'ORD(m2)',
            width: 78,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'overload_m2',
            colId: 'overload_m2',
            headerName: 'OVR(m2)',
            width: 78,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'stock_m2',
            colId: 'stock_m2',
            headerName: 'STOCK(m2)',
            pinned: 'right',
            width: 90,
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'diff_m2',
            colId: 'diff_m2',
            headerName: 'DIFF(m2)',
            width: 78,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum',
          },
          {
            field: 'ordered_pieces',
            colId: 'ordered_pieces',
            headerName: 'ORD(pcs)',
            width: 78,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'overload_pieces',
            colId: 'overload_pieces',
            headerName: 'OVR(pcs)',
            width: 78,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'stock_pieces',
            colId: 'stock_pieces',
            headerName: 'STOCK(pcs)',
            pinned: 'right',
            width: 90,
            totalDimension: true,
            aggFunc: 'sum'
          },
          {
            field: 'diff_pieces',
            colId: 'diff_pieces',
            headerName: 'DIFF(pcs)',
            width: 78,
            pinned: 'right',
            totalDimension: true,
            aggFunc: 'sum',
          }
        ]
      },
      async fetchGridTemplates() {
        const params = {
          grid_name: 'ordered_products'
        };
        try {
          this.templates = await this.$http.get(`generic/pivot_grid_table_templates/`, {params}).then(handlerResponse);
        } catch (e) {
          console.log(e);
        }
      },
      applyTemplate(currentTemplate) {
        try {
          this.gridOptions.columnApi.setColumnState(currentTemplate.params);
          this.gridOptions.api.setFilterModel(currentTemplate.filters);
        } catch (e) {
          this.gridOptions.columnApi.setColumnState([]);
        }
      },
      createTemplate() {
        this.$swal.fire({
          title: 'Creating grid template',
          input: 'text',
          inputPlaceholder: 'Enter grid template name',
          showCancelButton: true
        }).then(result => {
          const templateName = result.value;
          if (templateName) {
            const params = this.gridOptions.columnApi.getColumnState(),
              name = templateName, filters = this.gridOptions.api.getFilterModel(),
              grid_name = this.gridNameForTemplates;
            const savedData = {params, name, grid_name, filters};
            this.$http.post(`generic/pivot_grid_table_templates/`, savedData)
              .then(handlerResponse)
              .then(response => {
                const templateName = response.name;
                this.$notify(setNotifyData(`Grid template with name ${templateName} has been created`, '', 'success'));
                this.fetchGridTemplates();
              }).catch(error => notificationsRenderer(error.data, 'error'));
          }
        });
      },
      deleteSelectedTemplate() {
        const templateId = this.template.id, templateName = this.template.name;
        this.$http.delete(`generic/pivot_grid_table_templates/${templateId}/`).then(() => {
          this.template = null;
          this.$notify(setNotifyData(`Grid template with name ${templateName} has been deleted`, '', 'success'));
          this.fetchGridTemplates();
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      updateSelectedTemplate() {
        const templateId = this.template.id, templateName = this.template.name,
          params = this.gridOptions.columnApi.getColumnState(),
          grid_name = this.gridNameForTemplates, filters = this.gridOptions.api.getFilterModel();
        const savedData = {grid_name, filters, params};
        this.$http.put(`generic/pivot_grid_table_templates/${templateId}/`, savedData).then(() => {
          this.$notify(setNotifyData(`Grid template with name ${templateName} has been updated`, '', 'success'));
          this.fetchGridTemplates();
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      cleanFilters() {
        cleanFilters(this.searchData);
        this.setDefaultData();
        document.getElementById('start_week').value = '';
        document.getElementById('end_week').value = '';
      },
      saveFilters() {
        let savedFiltersObject = {...this.searchData};
        if (this.searchData.period === 'Week') {
          savedFiltersObject.period_date_start = document.getElementById('start_week').value;
          savedFiltersObject.period_date_end = document.getElementById('end_week').value;
        } else if (this.searchData.period === 'Month') {
          savedFiltersObject.period_date_start = this.searchData.start_month;
          savedFiltersObject.period_date_end = this.searchData.end_month;
        }
        saveFilters('order-products', savedFiltersObject);
      },
      async search() {
        const params = this.prepareSearchData();
        if (params.period_date_start && params.period_date_end) {
          this.gridOptions.api.showLoadingOverlay();
          try {
            const response = await this.$http.get(`sales/stock_ordered_product_difference_data/`, {params}).then(handlerResponse);
            this.columns = this.initializeGridColumns();
            // this.columns = addColIdToColumns(response.used_columns);
            this.periodList = response.data.period_list;
            this.columns = this.generateColumns(this.periodList);
            this.changeHideStateOfColumns();
            this.saveFilters();
            this.rowData = response.data.data;
            const totalRowData = this.createTotalRowData(response.data.data);
            this.gridOptions.api.setPinnedBottomRowData([totalRowData]);
          } catch (e) {
            console.log(e);
          }
          this.gridOptions.api.hideOverlay();
        } else {
          this.$notify(setNotifyData('Please select periods of planning', '', 'warn'));
        }
      },
      prepareSearchData() {
        const searchObject = {
          partner: getArrayByProperty(this.searchData.partner, 'id').toString(),
          status: getArrayByProperty(this.searchData.status, 'key').toString(),
          sales_order_created_by: getArrayByProperty(this.searchData.sales_order_created_by, 'id').toString(),
          delivery_method: getArrayByProperty(this.searchData.delivery_method, 'id').toString(),
          delivery_addresses: getArrayByProperty(this.searchData.delivery_addresses, 'id').toString(),
          stock_addresses: getArrayByProperty(this.searchData.delivery_method, 'id').toString(),
          smart_search: this.searchData.smart_search,
          descriptor: this.searchData.descriptor,
          period: this.searchData.period.toLowerCase()
        };

        if (this.searchData.period === 'Week') {
          searchObject.period_date_start = document.getElementById('start_week').value;
          searchObject.period_date_end = document.getElementById('end_week').value;
        } else if (this.searchData.period === 'Month') {
          searchObject.period_date_start = this.searchData.start_month ?
            moment(this.searchData.start_month).format('YYYY-MM') : '';
          searchObject.period_date_end = this.searchData.end_month ?
            moment(this.searchData.end_month).format('YYYY-MM') : '';
        }

        return searchObject;
      },
      generateColumns(periodList) {
        let generatingColumns = [...periodList].map((item) => {
          const column = {
            headerName: item
          };
          column.children = _.cloneDeep(this.childColumns);
          column.children.forEach((elem) => {
            elem.hide = !(this.searchData.periodDimensions.includes(elem.key));
            //elem.headerNameForExcel = item + ' ' + elem.field;
            elem.field = item + ' ' + elem.key;
            elem.colId = item + ' ' + elem.key;
            elem.width = 65;
          });
          return column;
        });
        const InsertPosition = _.findIndex(this.columns, {field: 'wood_certificate__name'}) + 1;
        generatingColumns = this.columns.slice(0, InsertPosition)
          .concat(generatingColumns)
          .concat(this.columns.slice(InsertPosition));

        return generatingColumns;
      },
      changeHideStateOfColumns(totalColumnsFlag = true) {
        this.columns = this.columns.map(column => {
          if (column.field && column.totalDimension && totalColumnsFlag) {
            const columnType = column.field.split('_')[1];
            column.hide = !this.searchData.totalDimensions.includes(columnType);
          }
          if (column.children) {
            column.children.forEach(item => {
              item.hide = !this.searchData.periodDimensions.includes(item.key);
            });
          }

          return column;
        });
        this.gridOptions.api.setColumnDefs([]); // it works for grid versions 19.0.0 and 19.1.1. Replace it to setColumnVisible api
        this.gridOptions.api.setColumnDefs(this.columns);
      },
      isNegative(number) {
        return Math.sign(number) === -1;
      },
      createTotalRowData(rowData) {
        let totalData = {};
        [...this.childColumns].forEach(item => {
          rowData.forEach((elem, index) => {
            for (let key in elem) {
              if (elem.hasOwnProperty(key) && key.includes(item.key)) {
                if (index === 0) {
                  if (key.includes('diff')) {
                    totalData[key] = this.isNegative(elem[key]) ? elem[key] : 0;
                  } else {
                    totalData[key] = elem[key];
                  }
                } else {
                  if (key.includes('diff')) {
                    if (this.isNegative(elem[key])) {
                      totalData[key] += elem[key];
                    }
                  } else {
                    totalData[key] += elem[key];
                  }
                }
              }
            }
          });
        });

        return totalData;
      },
      excelExport() {
        const state = this.gridOptions.columnApi.getColumnState();

        const groupping_by = state.filter(item => {
          return item.rowGroupIndex !== null;
        }).sort((a, b) => {
          return a.rowGroupIndex - b.rowGroupIndex;
        }).map(item => item.colId);

        let groupingQueryString = groupping_by.toString().replace('TxWxL', 'thickness,width,length');

        const params = Object.assign(this.prepareSearchData(),
          {
            groupping_by: groupingQueryString,
            period_measurements: this.searchData.periodDimensions.toString(),
            total_measurements: this.searchData.totalDimensions.toString()
          }
        );

        if (groupingQueryString.length) {
          this.$http.get('sales/stock_ordered_product_difference_data_excel/', {
            params,
            responseType: 'blob'
          }).then((response) => {
            const disposition = response.headers.get('content-disposition'),
              fileName = getFileNameFromContentDisposition(disposition, 'template-export');
            saveAs(response.body, fileName);
          }).catch(error => notificationsRenderer(error.data, 'error'));
        } else {
          this.$notify(setNotifyData('Choose grouping params', '', 'warn'));
        }
      },
      async openOrderedProductDialog(gridParams) {
        const params = Object.assign({}, this.prepareSearchData());
        const setDefaultPeriod = () => {
          params.period_date_start = this.periodList[0];
          params.period_date_end = this.periodList[this.periodList.length - 1];
        }
        const setCustomPeriod = (period) => {
          params.period_date_start = params.period_date_end = `${period[0]} ${period[1]} ${period[2]}`;
        }
        if (gridParams.colDef.cellRenderer !== 'group') {
          if (gridParams.colDef.field.includes(' | ')) {
            let period = gridParams.colDef.field.split(' ');
            setCustomPeriod(period);
          } else {
            setDefaultPeriod();
          }
        } else {
          if (gridParams.colDef.showRowGroup.includes(' | ')) {
            let period = gridParams.colDef.showRowGroup.split(' ');
            setCustomPeriod(period);
          } else {
            setDefaultPeriod()
          }
        }
        if (gridParams.node.allLeafChildren) {
          const productIdCallback = (item) => item.data.product_name_id;
          params.product_ids = gridParams.node.allLeafChildren
            .filter(productIdCallback)
            .map(productIdCallback)
            .toString();
        } else {
          params.product_ids = `${gridParams.data.product_name_id}`;
        }
        const response = await this.$http.get(`sales/sales_order_item_ordered_amount_data/`, {params}).then(handlerResponse);
        this.$root.$emit('openOrderedProductModal', {
          products: response.data,
          period_date_end: params.period_date_end,
          period_date_start: params.period_date_start
        });
      }
    },
    computed: {
      ...mapState('partners', ['customers']),
      ...mapState('woodware', {
        delivery_addresses: 'delivery_addresses',
        creators: 'users',
        delivery_methods: 'delivery_methods',
        stock_addresses: 'stock_addresses'
      }),
      gridHeight() {
        return {height: 'calc(100vh - 380px)'};
      }
    },
    mounted() {
      // TODO: jquery? why? https://pbs.twimg.com/media/EAi_yEoW4AA1rvd.jpg:large
      convertToWeekPicker($('#start_week'));
      convertToWeekPicker($('#end_week'));
      //this.columns = this.initializeGridColumns();
      //this.changeHideStateOfColumns();

      if (checkSavedFilterData('order-products')) {
        this.searchData = setFilters('order-products');
        if (this.searchData.period === 'Week') {
          document.getElementById('start_week').value = this.searchData.period_date_start;
          document.getElementById('end_week').value = this.searchData.period_date_end;
        } else if (this.searchData.period === 'Month') {
          this.searchData.start_month = this.searchData.period_date_start;
          this.searchData.end_month = this.searchData.period_date_end;
        }
      }
    },
    beforeMount() {
      this.setDefaultData();
      this.$store.dispatch('partners/getCustomers');
      this.$store.dispatch('woodware/getDeliveryAddresses');
      this.$store.cache.dispatch('woodware/getUsers');
      this.$store.cache.dispatch('woodware/getDeliveryMethods');
      this.$store.cache.dispatch('woodware/getStockAddresses');
      this.fetchGridTemplates();
    }
  }
</script>

<style lang="scss">
  .actions-form-container {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-gap: 0 15px;

    .action-btns {
      cursor: pointer;
      display: flex;
      justify-content: flex-end;
      width: 100%;

      img {
        width: 30px;
        height: 30px;
        margin-left: 10px;
      }
    }
  }

  .search-form-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 5px 15px;
    margin-top: 10px;
  }

  .grid {
    margin-top: 10px;
    height: 550px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/modules/production-planning/order-products/OrderProducts.vue